import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnChanges {
  @Input() title: string;
  @Input() data: Array<Highcharts.SeriesOptionsType>;
  @Input() columnsNames: string[];
  @Input() maxRows: number;
  @Input() internalColumnsNames: string[] = ['name', 'value'];
  @Output() rowHoverEvent = new EventEmitter<IteratorResult<string>>();
  private hoveredRows = new Set<string>();

  setHovered(row: any, hovered: boolean) {
    if(hovered) {
      this.hoveredRows.add(row[this.internalColumnsNames[0]]);
    } else {
      this.hoveredRows.delete(row[this.internalColumnsNames[0]]);
    }
    this.rowHoverEvent.emit(this.hoveredRows.values().next());
  }

  ngOnChanges() {
    // when data is changed, hovered rows are not valid anymore
    this.hoveredRows.clear();
  }
}
